import { Capacitor, registerPlugin } from '@capacitor/core'

interface SecureStoragePlugin {
  get(options: { key: string }): Promise<{ value: string | null }>
  set(options: { key: string; value: string }): Promise<void>
  remove(options: { key: string }): Promise<void>
}

const SecureStorage = registerPlugin<SecureStoragePlugin>('SecureStorage')

const PREFIX = 'pos_secure:'

export async function secureGet(key: string): Promise<string> {
  if (Capacitor.getPlatform() === 'android') {
    const result = await SecureStorage.get({ key })
    return result.value ?? '' 
  }
  try {
    return localStorage.getItem(PREFIX + key) ?? ''
  } catch {
    return ''
  }
}

export async function secureSet(key: string, value: string): Promise<void> {
  if (Capacitor.getPlatform() === 'android') {
    await SecureStorage.set({ key, value })
    return
  }
  try {
    localStorage.setItem(PREFIX + key, value)
  } catch {
    // localStorage недоступен
  }
}

export async function secureRemove(key: string): Promise<void> {
  if (Capacitor.getPlatform() === 'android') {
    await SecureStorage.remove({ key })
    return
  }
  try {
    localStorage.removeItem(PREFIX + key)
  } catch {
    // ignore
  }
}
